import React from 'react';
import { toast } from 'react-toastify';
import SubscriptionPanel from '../SubscriptionPanel';

const AccountTab = ({
  installer, stripeCapabilities, qbo, access,
  locationMode, subscriptionProps, canManageBilling,
}) => {
  const handleComingSoon = (feature) => {
    toast.info(`${feature} coming soon.`);
  };

  return (
    <>
      {/* Account Status */}
      {!locationMode && (
        <div className="card mb-4">
          <div className="card-header">
            <h4 className="mb-0">
              <i className="fa-sharp fa-regular fa-user-circle mr-2"></i>
              Account Status
            </h4>
          </div>
          <div className="card-body">
            {installer && (
              <div className="row">
                <div className="col-md-3 mb-3">
                  <strong>Account Type</strong><br />
                  <span className={`badge ${installer.is_trial ? 'badge-warning' : 'badge-success'}`}>
                    {installer.is_trial ? 'Trial Specialist' : 'Active Specialist'}
                  </span>
                </div>
                {/* Legacy tile, reading the deprecated `installer.subscription`
                    scalar. Hidden from non-staff for the 2026-08-11 release so
                    nothing labelled "Subscription" is visible while the per-shop
                    panel is dark-shipped. Restore alongside canManageBilling —
                    or delete once the server drops the scalar. */}
                {canManageBilling && (
                  <div className="col-md-3 mb-3">
                    <strong>Subscription</strong><br />
                    {installer.subscription || 'ASSIST'}
                  </div>
                )}
                <div className="col-md-3 mb-3">
                  <strong>Payment Status</strong><br />
                  <span className={`badge ${installer.onboarding_complete ? 'badge-success' : 'badge-warning'}`}>
                    {installer.onboarding_complete ? 'Setup Complete' : 'Setup Required'}
                  </span>
                  {installer.onboarding_complete && stripeCapabilities &&
                    Object.keys(stripeCapabilities).length > 0 &&
                    stripeCapabilities.us_bank_account_ach_payments !== 'active' && (
                    <div className="mt-1">
                      <span className="badge badge-warning">
                        <i className="fa-sharp fa-regular fa-exclamation-triangle mr-1"></i> Capabilities Pending
                      </span>
                    </div>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <strong>Member Since</strong><br />
                  {installer.created_at ? new Date(installer.created_at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : 'N/A'}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Billing is UX-gated here for a clean layout only — the server is the
          real authority on who can manage a shop's subscription. */}
      {canManageBilling && <SubscriptionPanel {...subscriptionProps} />}

      {/* Need Help */}
      <div className="card mb-4">
        <div className="card-header">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-life-ring mr-2"></i>
            Need Help?
          </h4>
        </div>
        <div className="card-body">
          <p>Having trouble with setup or have questions?</p>
          <div className="d-flex flex-wrap">
            <a href="mailto:support@jobvious.com" className="btn btn-outline-primary btn-sm mr-2 mb-2">
              <i className="fa-sharp fa-regular fa-envelope mr-1"></i> Contact Support
            </a>
            <button className="btn btn-outline-secondary btn-sm mr-2 mb-2" onClick={() => handleComingSoon('Help Center')}>
              <i className="fa-sharp fa-regular fa-book mr-1"></i> Help Center
            </button>
            <button className="btn btn-outline-secondary btn-sm mb-2" onClick={() => handleComingSoon('Tutorials')}>
              <i className="fa-sharp fa-regular fa-video mr-1"></i> Tutorials
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default AccountTab;
